import React from "react";

import type { BookingWidgetProps } from "./types";
import SiteContainer from "src/components/siteContainer/siteContainer";
import { ModuleWrapperV2 } from "src/components/moduleWrapper/moduleWrapper.v2";
import SearchWidgetFullControl from "src/components/searchWidgetSection/searchWidgetFullControl/search.widget";

export default class BookinWidget extends React.Component<BookingWidgetProps> {

  backgroundColor = this.props.data.item?.background_color?.value || "transparent"
  name = this.props.data.item?.name

  get padding() {
    return { top: this.props.data?.item?.padding_top, bottom: this.props.data?.item?.padding_bottom };
  }

  get overlayColor(){
    const { overlay, background_overlay_opacity, background_color_overlay } = this.props.data.item
    if( overlay && background_color_overlay?.value && background_overlay_opacity) return background_color_overlay.value +  Math.floor( background_overlay_opacity / 100 * 255 || 0 * 255).toString(16);
    return "";
  }

  render(): React.ReactNode {
    const { background_image } = this.props.data.item;
    return (
      <SiteContainer fullwidth={true}>
        <ModuleWrapperV2 paddings={this.padding}
         anchor={""}
         backgroundColor={this.backgroundColor}
         backgroundImage={background_image?.imageFile}
         name={this.name}
         roundedCorners={false}
         overlayColor={this.overlayColor}
        >
          <SearchWidgetFullControl
            item={this.props.data.item}
            removeMargin
            defaultLanguage={this.props.data?.defaultLanguage}
            selectedLanguage={this.props.data?.selectedLanguage}
          />
        </ModuleWrapperV2>
      </SiteContainer>
    )
  }
}